"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSwipe = void 0;
var _react = require("react");
// Минимальное расстояние для распознавания свайпа
const SWIPE_THRESHOLD = 50;
const useSwipe = params => {
  const {
    onSwipeLeft,
    onSwipeRight
  } = params;
  const [startX, setStartX] = (0, _react.useState)(0);
  const [startY, setStartY] = (0, _react.useState)(0);
  const handleStart = (0, _react.useCallback)(e => {
    const point = e.touches[0];
    setStartX(point.clientX);
    setStartY(point.clientY);
  }, []);
  const handleEnd = (0, _react.useCallback)(e => {
    const point = e.changedTouches[0];
    const deltaX = point.clientX - startX;
    const deltaY = point.clientY - startY;

    // Проверяем, что это горизонтальный свайп
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD) {
      if (deltaX > 0) {
        onSwipeRight();
      } else {
        onSwipeLeft();
      }
    }
  }, [startX, startY, onSwipeLeft, onSwipeRight]);
  (0, _react.useEffect)(() => {
    document.addEventListener('touchstart', handleStart);
    document.addEventListener('touchend', handleEnd);
    return () => {
      document.removeEventListener('touchstart', handleStart);
      document.removeEventListener('touchend', handleEnd);
    };
  }, [handleEnd, handleStart]);
};
exports.useSwipe = useSwipe;